module.exports = __webpack_public_path__ + "static/success.img-70234451a6754b4f7b9bf28938db3fc1.svg";